import React, { useState, useEffect } from 'react';
import {
    Search, Menu, User, Globe, Heart, Star, Zap, Home,
    Filter, Key, ShieldCheck, MapPin, Map, HelpCircle, Phone, Mail
} from 'lucide-react';

const LocationContent = () => (
    <div className="pt-32 px-6 max-w-[1600px] mx-auto animate-fade-in pb-20 h-screen flex flex-col">
        <div className="flex flex-col lg:flex-row gap-12 h-full">
            <div className="lg:w-1/3 pt-8">
                <h1 className="text-5xl font-serif font-bold text-primary mb-6">Le Nostre Location</h1>
                <p className="text-gray-600 mb-10 text-lg leading-relaxed">Presenti nelle principali città italiane e nelle mete turistiche più esclusive.</p>
                <div className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm">
                    <div className="flex items-center gap-3 mb-4 text-primary"><MapPin className="text-brand w-6 h-6" /><h3 className="font-bold text-xl">Top Destinations</h3></div>
                    <ul className="text-base text-gray-600 space-y-3">
                        <li className="flex justify-between border-b border-gray-100 pb-2"><span>Milano</span> <span className="font-semibold text-brand">15 Proprietà</span></li>
                        <li className="flex justify-between border-b border-gray-100 pb-2"><span>Roma</span> <span className="font-semibold text-brand">12 Proprietà</span></li>
                        <li className="flex justify-between border-b border-gray-100 pb-2"><span>Firenze</span> <span className="font-semibold text-brand">8 Proprietà</span></li>
                    </ul>
                </div>
            </div>
            <div className="lg:w-2/3 h-[600px] bg-gray-200 rounded-3xl overflow-hidden relative shadow-xl">
                <img src="https://images.unsplash.com/photo-1478860409698-8707f313ee8b?q=80&w=2070&auto=format&fit=crop" className="w-full h-full object-cover opacity-90" alt="Map" />
                <div className="absolute inset-0 flex items-center justify-center"><button className="bg-white px-8 py-4 rounded-full shadow-2xl font-bold flex items-center gap-3 text-primary hover:scale-110 transition-transform"><Map className="text-brand w-6 h-6" /> Esplora Mappa</button></div>
            </div>
        </div>
    </div>
);

export default LocationContent